import React from "react";
import { Table } from "antd";
import { formatDate } from "../utils";
import { Carousel } from "antd";
import { useHistory } from "react-router-dom";
import { PrimaryTableRowText } from "../../../shared/globalStyling/styledText";
import MediaFetcher from "../library/MediaFetcher";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./../library/creativestyle.css";

// Helper function to get unique medias (moved outside component to avoid hooks issues)
const getUniqueMedias = (medias) => {
  return Array.from(
    new Map(medias.map(media => [media.key, media])).values()
  );
};

const AssignedAdGroupsTable = ({ assignedAdGroupUnit }) => {
  const history = useHistory();
  const PrevArrow = props => {
    const { className, style, onClick } = props;
    return (
      <LeftOutlined
        className={className}
        style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const NextArrow = props => {
    const { className, style, onClick } = props;
    return (
      <RightOutlined
        className={className}
        style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const columns = [
    {
      title: "Ad Group Name",
      dataIndex: "name",
      key: "name",
      width: "25%",
      render: (name, record) => {
        return (
          <div
            onClick={() => {
              // Determine media type from the first media in the ad group
              const firstMedia = record.medias?.[0];
              const mediaType = firstMedia?.type?.toUpperCase();
              const mediaTypePath = mediaType === 'VIDEO' ? 'video' : 'display';
              history.push(`/creatives/${mediaTypePath}/groups/${record.id}`);
            }}
          >
            <PrimaryTableRowText
              text={
                <span style={{ color: "#1890FF", fontWeight: "bold" }}>
                  {name}
                </span>
              }
            />{" "}
          </div>
        );
      },
    },
    {
      title: "Ad Units",
      dataIndex: "AD Unit Number",
      key: "Ad Unit Number",
      width: "8%",
      render: (_, record) => record.medias.length,
    },
    {
      title: "Gallery",
      dataIndex: "medias",
      key: "medias",
      render: medias => {
        const uniqueMedias = getUniqueMedias(medias);

        // Dynamic carousel settings based on number of items
        const itemCount = uniqueMedias.length;
        const slidesToShow = Math.min(itemCount, 5); // Don't show more slides than items
        const slidesToScroll = Math.min(itemCount, 5);

        const settings = {
          dots: false,
          infinite: itemCount > slidesToShow, // Only infinite if more items than shown
          speed: 500,
          slidesToShow,
          slidesToScroll,
          arrows: itemCount > slidesToShow, // Only show arrows if scrolling is needed
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
        };

        return (
          <div style={{ width: "90%", maxWidth: "750px", margin: "0 auto" }}>
            <Carousel {...settings}>
              {uniqueMedias.map((media, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px", // Box height
                      width: "100px", // Box width
                      background: "#f5f5f5", // Light background for box effect
                      border: "1px solid #ddd", // Light border
                      overflow: "hidden", // Ensure content stays inside
                    }}
                  >
                    <MediaFetcher
                      mediaKey={media.key}
                      width="100%"
                      height="100px"
                      objectFit="contain"
                    />
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        );
      },
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "15%",
      render: text => formatDate(text),
    },
  ];

  return (
    <Table
      scroll={{ x: "100%" }} // adjust the width to your needs
      tableLayout="fixed"
      columns={columns}
      dataSource={assignedAdGroupUnit}
    />
  );
};

export default AssignedAdGroupsTable;
